// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"aa118974606ebf839e55","245":"6fa2daf837f8a7984981","452":"f3150358ace616bd5610","453":"a3b5db2d89944dfa4f86"}[chunkId] + ".js";
};